import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomTable, DebouncedSearch } from "../../../shared";
import { useAccountUploads } from "../hooks";
import { Box, Button, Link, Stack } from "@mui/material";
import { PlAndBsListFilterSection } from "./PlAndBsListFilterSection";

export const AccountUploads = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isStoreAdmin = location.pathname.includes("/store-admin");
  //   const isEditable = usePermission("pl-bs-account-modify");

  const {
    state,
    handleSearch,
    handleClearFilter,
    handleApplyFilter,
    handleChangeFilter,
    handleClearAllFilter,
    downloadUploadedFile,
  } = useAccountUploads();

  const columns = React.useMemo(() => {
    const accountUploadReports = [
      {
        Header: "Month ",
        accessor: "month",
      },
      {
        Header: "Financial Year",
        accessor: "year",
      },
      {
        Header: "File",
        accessor: "excel_file",
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                textDecoration: "none",
                cursor: "pointer",
                color: "info.main",
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
            >
              <Link
                underline="none"
                component="button"
                variant="body2"
                onClick={() => downloadUploadedFile(row?.original?.id)}
              >
                <b>Download</b>
              </Link>
            </Box>
          );
        },
      },
      {
        Header: "Submitted By",
        accessor: "user_name",
      },
      {
        Header: "Last Uploaded on",
        accessor: "last_updated_on",
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        accessor: (row) => {
          return (
            <Box
              component="img"
              alt="details"
              src="/icons/arrow_forward.svg"
              onClick={() => navigate(`edit/${row.id}`)}
            />
          );
        },
      },
    ];

    // Conditionally add the "Store" column for non-store admins
    if (!isStoreAdmin) {
      accountUploadReports.unshift({
        Header: "Store",
        accessor: "store_name",
      });
    }

    return accountUploadReports;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStoreAdmin]);

  return (
    <CustomTable
      columns={columns}
      data={state.accountUploadList}
      defaultSearch={false}
      isLoading={state.tableLoading}
      filterContent={
        <DebouncedSearch value={state.searchText} onChange={handleSearch} />
      }
      filterSection={
        <Stack
          width="100%"
          gap="16px"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Stack flexDirection="row" gap="16px">
            <PlAndBsListFilterSection
              filter={state.filter}
              accountMonthList={true}
              financialYearList={true}
              storeList={!isStoreAdmin}
              handleChangeFilter={handleChangeFilter}
            />
          </Stack>
          <Button
            size="large"
            variant="contained"
            onClick={() => handleApplyFilter(state.filter.values)}
            disabled={state.filter.isFilterApplied}
          >
            Apply
          </Button>
        </Stack>
      }
      filterApplied={state.filter.appliedFilters}
      onAllFilterClear={handleClearAllFilter}
      onFilterClear={handleClearFilter}
      onRowLink={(row) => `edit/${row.id}`}
    />
  );
};
